module.exports = __webpack_public_path__ + "img/error500.dc5c19f7.gif";